/**
 * Booking Store
 * ----------------------------
 *
 */
export const useBookingStore = defineStore('booking', () => {
    /**
     * Vouchers
     * ------------------------------------------------------------------------------------------
     */
    const voucherCode = ref<VoucherCode>({ voucherCode: '' });

    /**
     * Other
     * ------------------------------------------------------------------------------------------
     */
    const acceptedTermsAndConditions = ref<AcceptedTermsAndConditions>({ });

    /**
     * ------------------------------------------------------------------------------------------
     */

    function reset() {
        acceptedTermsAndConditions.value = {};
        voucherCode.value = { voucherCode: '' };
    }

    return {
        voucherCode,
        acceptedTermsAndConditions,

        reset,
    };
}, {

    persist: {
        ...storePersist.storePersistOptions,
        key: 'booking-v6',
    },
});
